export default __webpack_public_path__ + "static/media/redirectOk.d3daadf9.png";